import {
    TreatmentRequestDetailsGroup,
    useTreatmentRequestDetailsStore
} from '@/features/treatment-requests/store/treatmentRequestDetailsStore'
import {useEffect, useMemo} from 'react'
import {ObjectKeys} from '@/utilities/helpers'
import {useMutationState} from '@tanstack/react-query'
import {MUTATION_KEYS} from '@/queryClient'
import {HttpUpdateTreatmentRequestOptions} from '@/features/treatment-requests/services/treatment-requests.http'
import {EditDetailsSectionButtons} from '@/components/commons/edit-details-section-buttons/EditDetailsSectionButtons'

interface TreatmentRequestEditButtonsProps {
    groupName: TreatmentRequestDetailsGroup
    isConfirmDisabled: boolean
    onCancel: () => void
    onConfirm: () => void
    isDisabled: boolean
}

export const TreatmentRequestEditButtons = ({
    groupName,
    isConfirmDisabled,
    onCancel,
    onConfirm,
    isDisabled
}: TreatmentRequestEditButtonsProps) => {
    const currentEditingFieldsGroup = useTreatmentRequestDetailsStore(state => state.editingFieldsGroup)
    const setEditingFieldsGroup = useTreatmentRequestDetailsStore(state => state.setEditingFieldsGroup)

    // retrieve pending state from mutation
    const updateTreatmentRequestState = useMutationState({
        filters: {mutationKey: [MUTATION_KEYS.UPDATE_TREATMENT_REQUEST], status: 'pending'},
        select: mutation => ({
            variables: mutation.state.variables as HttpUpdateTreatmentRequestOptions
        })
    })

    // constants
    const isLoadingUpdate = useMemo(
        () => !!ObjectKeys(updateTreatmentRequestState).length,
        [updateTreatmentRequestState]
    )
    const isActive = useMemo(() => groupName == currentEditingFieldsGroup, [groupName, currentEditingFieldsGroup])

    // clear store on unmount
    useEffect(() => {
        return () => setEditingFieldsGroup(null)
    }, [])

    return (
        <EditDetailsSectionButtons
            isActive={isActive}
            isLoading={isLoadingUpdate}
            isDisabled={isDisabled || (isConfirmDisabled && isActive)}
            onConfirm={onConfirm}
            onEdit={() => setEditingFieldsGroup(groupName)}
            onCancel={() => {
                setEditingFieldsGroup(null)
                onCancel()
            }}
        />
    )
}
